'use strict';

const interopDefault = (mod) => mod.default || mod;

exports.interopDefault = interopDefault;
